import { render, staticRenderFns } from "./RHeader.vue?vue&type=template&id=6168cf1d&scoped=true"
import script from "./RHeader.vue?vue&type=script&lang=js"
export * from "./RHeader.vue?vue&type=script&lang=js"
import style0 from "./RHeader.vue?vue&type=style&index=0&id=6168cf1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6168cf1d",
  null
  
)

export default component.exports